<template>
  <v-container class="fill-height pa-0" fluid>
    <v-card class="d-flex justify-center align-center login-page-container">
      <v-row>
        <v-col cols="12" md="6" class="pa-0">
          <v-card tile flat class="right-side-card">
            <v-card-text>
              <v-row>
                <v-col cols="12" sm="12" md="12" class="d-flex justify-center">
                  <FacebookAuthBtn class="full-width" />
                </v-col>
                <v-col cols="12" sm="12" md="12" class="d-flex justify-center">
                  <GoogleAuthBtn class="full-width" />
                </v-col>
              </v-row>
              <v-divider class="my-2" />
              <v-row>
                <v-col cols="12" md="12" class="d-flex justify-center">
                  <v-form class="full-width" v-on:submit.prevent="login" v-model="isLoginFormValid">
                    <v-text-field outlined dense label="Email" name="email" type="text" required :rules="emailRules" v-model="email" />
                    <v-text-field outlined dense :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'" label="Password" name="password" :type="showPassword ? 'text' : 'password'" required :rules="passwordRules" v-model="password" @click:append="showPassword = !showPassword" />
                    <p>
                      <router-link :to="{ name: 'PasswordForgot' }">Forgot password?</router-link>
                    </p>
                    <v-btn color="secondary" type="submit" block :disabled="!isLoginFormValid">Login</v-btn>
                  </v-form>
                </v-col>
              </v-row>
            </v-card-text>
            <div class="text-center mb-8">
              <router-link :to="{ name: 'Signup' }">Create an account for FREE</router-link>
            </div>
            <div class="text-center">
              This site is protected by reCAPTCHA and the Google
              <a href="https://policies.google.com/privacy">Privacy Policy</a> and <a href="https://policies.google.com/terms">Terms of Service</a> apply.
            </div>
          </v-card>
        </v-col>
        <v-col cols="12" md="6" class="d-flex pa-0">
          <v-card tile flat class="left-side-card">
            <div class="heading-h1 white--text pa-4">We’re here to put pep in your kid’s step.</div>
            <div class="body-heading-medium white--text pa-4 font-weight-regular">We’ve got everything you need to motivate your kids without much gnashing of teeth. Hit that Login button to set Quests, check progress, approve completion and more!</div>
          </v-card>
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>

<script>
  /*eslint-disable no-undef */

  import FacebookAuthBtn from "@/components/FacebookAuthBtn";
  import GoogleAuthBtn from "@/components/GoogleAuthBtn";

  export default {
    name: "ParentLoginPage",
    data() {
      return {
        showPassword: false,
        email: "",
        password: "",
        isLoginFormValid: false,
        emailRules: [(v) => !!v || "E-mail is required", (v) => /.+@.+\..+/.test(v) || "E-mail must be valid"],
        passwordRules: [(v) => !!v || "Password is required"],
        user: {},
        recaptchaSiteKey: process.env.GOOGLE_RECAPTCHA_V3_SITE_KEY,
      };
    },
    components: {
      FacebookAuthBtn,
      GoogleAuthBtn,
    },

    created() {
      this.checkLogin();
    },

    updated() {
      this.checkLogin();
    },
    computed: {
      isLoggedIn: function() {
        return this.$store.getters.isLoggedIn;
      },
    },
    methods: {
      redirectToDashboard(role) {
        if (role) {
          if (role.indexOf("parent") > -1) {
            this.$router.replace("/parentdashboard");
          }

          if (role.indexOf("child") > -1) {
            this.$router.replace("/childdashboard");
          }
        } else {
          this.$router.replace("/oops");
        }
      },

      login() {
        this.$store.commit("setLoadingStatus", true);
        grecaptcha.ready(() => {
          grecaptcha
            .execute(this.recaptchaSiteKey, { action: "submit" })
            .then(
              (token) => {
                this.$http
                  .post("/recaptcha/verify", { token: token })
                  .then((response) => {
                    this.$http
                      .post("/auth", { email: this.email, password: this.password })
                      .then((response) => this.loginSuccess(response))
                      .catch((error) => this.loginFail(error));
                  })
                  .catch((error) => this.loginFail(error));
              },
              (error) => {
                console.error(error);
                this.loginFail(error);
              }
            )
            .catch((error) => {
              console.error(error);
              this.loginFail(error);
            });
        });
      },

      loginSuccess(response) {
        if (!response.data.token) {
          this.loginFail();
          return;
        }
        this.user = this.$formatter.extend(response.data);
        this.user.lastLogin = this.$datetime.getCurrentTimeInMillisec();

        localStorage.token = response.data.token;
        localStorage.role = response.data.role;
        this.fetchPointBalance();

        this.redirectToDashboard(response.data.role);

        this.$store.commit("setLoadingStatus", false);
      },

      loginFail(error) {
        console.error(error);

        this.$store.commit("setError", {
          message: "Opps! please check your account information or activate your account and try again.",
          type: "error",
        });

        delete localStorage.token;
        delete localStorage.role;
        this.$store.commit("setLoadingStatus", false);
      },

      fetchPointBalance() {
        this.$store.commit("setLoadingStatus", true);

        if (localStorage.token) {
          this.$http
            .get("/points")
            .then((response) => {
              //TODO think about using actions instead of directly committing
              //https://vuex.vuejs.org/guide/actions.html

              this.user = this.$formatter.extend(this.user, response.data);
              this.$sessionUser._updateUserInfo(this.user);
              this.$store.commit("setUserInfo", this.user);

              this.$store.commit("setLoadingStatus", false);
            })
            .catch(() => {
              console.log("failed to retrieve points");
              this.$store.commit("setLoadingStatus", true);
            });
        }
      },

      checkLogin() {
        if (this.isLoggedIn) {
          this.redirectToDashboard(this.user.role);
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import "@/styles/variables.scss";

  .login-page-container {
    background: url(../assets/parent_login_bcg_img.png);
    background-repeat: no-repeat;
    background-size: cover;
    border-radius: 0px !important;
    padding: 10% 16%;
    width: 100%;

    .left-side-card {
      background-color: $primary-blue !important;
      padding: 12% 8%;
      height: 42rem;
    }

    .right-side-card {
      padding: 12% 8%;
      height: 42rem;
    }

    .full-width {
      width: 100% !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ParentLoginPage.vue